export default {"src":"/_next/static/media/star-logo.3c7a9f30.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};